import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { IsString, IsOptional, MaxLength, IsNotEmpty } from 'class-validator'

export class CreateSubjectTypeDto {
  @ApiProperty({
    example: 'CORE',
    description: 'Unique code for the subject type',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(64)
  code!: string

  @ApiProperty({
    example: 'Enseignement fondamental',
    description: 'Display label',
  })
  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  label!: string

  @ApiPropertyOptional({ description: 'Optional description' })
  @IsString()
  @IsOptional()
  description?: string

  @ApiPropertyOptional({
    description: 'Hex color (e.g. #3B82F6)',
    example: '#3B82F6',
    maxLength: 7,
  })
  @IsOptional()
  @IsString()
  @MaxLength(7)
  color?: string
}
